import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function controlMeasureTypeAdd(newDetails: any) {
    try {
        const response = await apiPost('core', `control-measure-type`, newDetails);
        return response;
    } catch (e) { }
}

export async function controlMeasureTypeUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `control-measure-type/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeControlMeasureType(id: any) {
    try {

        return await apiDelete('core', `control-measure-type/${id}`);
    } catch (e) { }
}

export async function controlMeasureAdd(newDetails: any) {
    try {
        const response = await apiPost('core', `control-measure`, newDetails);
        return response;
    } catch (e) { }
}

export async function controlMeasureUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `control-measure/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeControlMeasure(id: any) {
    try {

        return await apiDelete('core', `control-measure/${id}`);
    } catch (e) { }
}